/**
 * This Symbol will be provided to every
 * component to let them know whether a partial
 * or a full view should be rendered.
 */
export const PARTIAL_VIEW = Symbol('partial-view')

/**
 * Selector for a partial view of the app.
 */
export const homeAppSelector = '.gsiCharts'

/**
 * Full app selector.
 */
export const fullAppSelector = '#gsiDashboards'

/**
 * Common selector for all components.
 */
export const topLevelClass = 'gsi-data-visualization'

/**
 * List of expected IDs for the top level dimensions.
 */
export enum DIMENSION_IDS {
    GOV_RESPONSE = 'r',
    VULNERABILITY = 'v',
    PREVALENCE = 'p',
    GDP_CORRELATION = 'g',
    IMPORTING_RISK = 'i'
}
